function waitForElm(selector) {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver((mutations) => {
      if (document.querySelector(selector)) {
        observer.disconnect();
        resolve(document.querySelector(selector));
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  // Language Switcher
  document.querySelectorAll('.nav-lang-switcher').forEach(selectLang => {
    selectLang.addEventListener('change', event => {
      let current_locale = Shopify.locale == 'en' ? '' : Shopify.locale + '/';
      let new_locale = selectLang.value == 'en' ? '' : selectLang.value + '/';
      location.href = location.href.replace(location.host + '/' + current_locale, location.host + '/' + new_locale);
    });
  })

  // Language Switcher - Variation
  document.querySelectorAll('.nav-lang-switcher-variation a').forEach(selectLang => {
    selectLang.addEventListener('click', event => {
      let current_locale = Shopify.locale == 'en' ? '' : Shopify.locale + '/';
      let new_locale = selectLang.dataset.locale == 'en' ? '' : selectLang.dataset.locale + '/';
      location.href = location.href.replace(location.host + '/' + current_locale, location.host + '/' + new_locale);
    });
  })
  
  var scrollToReviewsSpan = document.getElementById("scrollToReviews");
  if (scrollToReviewsSpan) {
    scrollToReviewsSpan.addEventListener("click", function () {
      var reviewsSection = document.querySelector(
        ".js-oke-widgetSize.oke-is-large, .js-oke-widgetSize.oke-is-small"
      );

      if (reviewsSection) {
        // Scroll smoothly to the reviews section
        reviewsSection.scrollIntoView({
          behavior: "smooth",
        });
      }
    });
  }

  waitForElm(".product-details-wrapper [data-oke-metafield-data]").then(
    (elm) => {
      const metafield = jQuery.parseJSON(elm.textContent);
      if (metafield.reviewCount == 0) {
        $(".product-details-wrapper [data-oke-star-rating]").css({
          display: "none",
        });
        $(".trustedbypdp").css({ display: "none" });
      } else {
        $(".product-details-wrapper [data-oke-star-rating]").css({
          display: "block",
        });
        $(".trustedbypdp").css({ display: "block" });
      }
    }
  );
});

const customSelectors = {};

const menuLinks = document.querySelectorAll(".mega_menu_hover_line");
const subMenuContents = document.querySelectorAll(".sub_menu");

menuLinks.forEach((menuLink) => {
  menuLink.addEventListener("mouseover", function (e) {
    const element = e.target.closest(".mega_menu_hover_line"); // Ensures we always target the <a> tag
    
    if (!element) return; // Safety check

    menuLinks.forEach((menuLink) => {
      menuLink.classList.remove("mega-menu__link--active");
    });
    element.classList.add("mega-menu__link--active");

    const menu_title = element.title; // Use the closest <a> title
    const menu_link = element.href;

    if (menu_title != 'Shop All Products') {
    //if (!/\/collections\/all$/.test(menu_link)) {
      subMenuContents.forEach((subMenuContent) => {
        subMenuContent.classList.remove("active");
        const handle = subMenuContent.getAttribute("data-menu-title");
        if (handle == menu_title) {
          subMenuContent.classList.add("active");
        }
      });
    //}
    }
  });
});


const inputElement = document.querySelector(".docapp-coupon-input--input");
if (inputElement)
  inputElement.setAttribute("placeholder", "+ ENTER DISCOUNT CODE");

function sanitizePrice(priceString) {
  // Remove any non-digit characters except for the decimal point
  let numericString = priceString.replace(/[^\d.]/g, "");
  const numeric = priceString.includes(",")
    ? numericString * 1
    : numericString * 100;
  // Convert the clean string to a float to handle numbers correctly
  return parseFloat(numeric);
}

function calculatePriceWithTaxes(price, country, showTaxes = false) {
  const taxData = window.taxData;

  const noPriceDisplayCountries = ["US", "CA"];

  let taxRate = taxData[country];
  
  if(taxRate == 0) {
    return `<span class="tax-excl-price">${price.toString().replace(/\./g, ",")} ${window.globalVariables.money_format.replace("{{amount_with_comma_separator}} ","")}</span><span class='tax tax-excl'> Excl. Tax</span>`;
  }
  
  let taxInclusivePrice = price * (1 + taxRate);
  let formattedTaxInclusivePrice = Shopify.formatMoney(
    taxInclusivePrice,
    window.globalVariables.money_format
  );
  let formattedTaxExclusivePrice = Shopify.formatMoney(
    price,
    window.globalVariables.money_format
  );

  if (country === "LU") {
    return `<span class="tax-excl-price">${formattedTaxExclusivePrice}</span><span class='tax tax-excl'> Excl. Tax</span> <span>${formattedTaxInclusivePrice}</span><span class='tax'> Incl. Tax</span>`;
  } else if (taxRate !== undefined && showTaxes) {
    return formattedTaxInclusivePrice + "<span class='tax'> Incl. Tax</span>";
  } else if (taxRate !== undefined) {
    return formattedTaxInclusivePrice;
  }

  return noPriceDisplayCountries.includes(country)
    ? formattedTaxExclusivePrice
    : formattedTaxExclusivePrice +
        (showTaxes ? "<span class='tax'> Excl. Tax</span>" : "");
}

document.addEventListener("DOMContentLoaded", function () {
  const customerCountry = window.customerCountry;
  waitForElm(".cbb-frequently-bought-selector-label-regular-price", 5000).then(
    () => {
      function changePrices() {
        const prices = document.querySelectorAll(
          ".cbb-frequently-bought-selector-label-regular-price, .cbb-frequently-bought-selector-label-compare-at-price, .cbb-frequently-bought-selector-label-sale-price, .cbb-frequently-bought-total-price-sale-price, .cbb-frequently-bought-total-price-was-price, .cbb-frequently-bought-total-price-regular-price"
        );
        prices.forEach((price) => {
          const hasAnyClass = [
            "cbb-frequently-bought-selector-label-compare-at-price",
            "cbb-frequently-bought-total-price-was-price",
          ].some((className) => price.classList.contains(className));

          const priceElement = price.querySelector(".money")
            ? price.querySelector(".money")
            : price;

          //console.log("priceElement", priceElement.textContent);
          const priceWithTaxes = calculatePriceWithTaxes(
            sanitizePrice(priceElement.textContent),
            customerCountry,
            hasAnyClass ? false : true
          );

          //console.log("priceWithTaxes", priceWithTaxes);
          priceElement.innerHTML = priceWithTaxes;
        });
      }

      setTimeout(() => {
        const variantSelects = document.querySelectorAll(
          ".cbb-recommendations-variant-select"
        );

        //console.log("variantSelects", variantSelects);

        if (variantSelects.length > 0) {
          variantSelects.forEach((select) => {
            select.addEventListener("change", () => {
              changePrices();
            });
          });
        }

        changePrices();
      }, 1000);
    }
  );
});



$(".submenu-accordion").on("click", function () {
  $(".submenu-accordion").not(this).removeAttr("open");

  /*
  $(this).parent().find(".nav-item-shop-topical-skincare .submenu-accordion").each(()=>{      
    if($(this).attr("open")){
        $(".nav-item-shop-topical-skincare .submenu-div .nav-item").show();
    }else{
        $(".nav-item-shop-topical-skincare .submenu-div .nav-item").hide();    
    }
  })
  */
});


$(document).ready(function () {
  $(".products-menu").hover(function () {
    let $this = $(this);
    let topLevelAnchorUrl = $this.children("a").attr('href').trim();
    
    $(".sideproduct .active").removeClass("active");
    $(".nav-item.nav-item-anim.py-0 a").removeClass("mega-menu__link--active");
    
    if (topLevelAnchorUrl.includes('/collections/all')) {
      if (document.documentElement.classList.contains('abtest-menu-variation-1')) {
        $this.find('.nav-item:eq(1) a').addClass("mega-menu__link--active");
        $this.find('.sub_menu:eq(1)').addClass("active");
        $this.find('.nav-item-all-devices').children("ul").show();
      } else {
        $this.find('.nav-item:eq(0) a').addClass("mega-menu__link--active");
        $this.find('.sub_menu:eq(0)').addClass("active");
      }
    }
  });

  $('.dropdown-menu .nav-item.has-children').hover(function() {
    $(this).children('ul').show();
    $(this).siblings().children('ul').hide();
  });
  
  $(".sideproduct").hover(function () {
    var menuTitle = $(this).find(".active").attr("data-menu-title");
    console.log(menuTitle);
      
    if(menuTitle == "Topical Skincare" || menuTitle == "Topicals for Anti-Aging" || menuTitle == "Topicals for Blemish-Prone Skin" || menuTitle == "Hydrocolloid Patch Refills" || menuTitle == "Shop All Topical Skincare" ){
      $(".has-children .thirdlink-child-link").hide();               
      $(".nav-item-all-devices a").removeClass("mega-menu__link--active");          
      $(".nav-item-skin-care a").addClass("mega-menu__link--active");
      $(".nav-item-skin-care").find(".thirdlink-child-link").show();

    } else if(menuTitle == "Devices" || menuTitle == "Anti-Aging Devices" || menuTitle == "Anti-Acne Devices" || menuTitle == "Mini Devices" ){
      $(".has-children .thirdlink-child-link").hide();            
      $(".nav-item-all-devices a").addClass("mega-menu__link--active");
      $(".nav-item-all-devices").find(".thirdlink-child-link").show();

    } else{
      $(".nav-item-skin-care a").removeClass("mega-menu__link--active");
      $(".nav-item-skin-care").find(".thirdlink-child-link").hide();
    } 
  });

  function checkDesktop() {
    return $(window).width() > 768; // Adjust breakpoint as needed
  } 
});